import CrudRepository from './CrudRepository'
export default class SocialResponsibilityCategoriesRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/responsibilityCategory/web')
  }
}
